<script>
    import Messages from "./helpers/messages/Messages";
    import Auth from "./helpers/Auth";
    import LoadingIcon from "./LoadingIcon.svelte";
    import Header from "./Header.svelte";
    import Footer from "./Footer.svelte";
    import {validateEmail} from "../lib/Common.svelte";
    import {setupI18n, _} from "../lib/i18n";

    export let language = 'en-US';
    setupI18n({ withLocale: language });
    export let auth_endpoint = '/auth/';

    export let csrfKey = '_csrf';
    export let csrfValue = null;

    Messages.registerLanguageVersion(language);

    let email;

    let mainError = null;
    let emailError = null;
    let emailRed = false;

    $: email && checkFields();

    function checkFields() {
        emailRed = false;
        if (email && !validateEmail(email)) {
            emailRed = true;
        }
    }

    let loading = false;
    let showMailSend = false;

    const auth = new Auth({
        auth_endpoint
    });

    let isLoading = false;
    const onSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        emailError = null;
        mainError = null;
        showMailSend = false;

        isLoading = true;
        try {
            const response = await auth.passwordReset(email, csrfKey, csrfValue);
            if (response.status === 'ok') {
                showMailSend = true;
            }
        } catch (error) {
            if (error.response.data.errors) {
                if (error.response.data.errors.email) {
                    emailError = error.response.data.errors.email;
                    //mainError = error.response.message;
                    mainError = error.response.data.errors.email;
                }
            }
        }
        isLoading = false;
    }
</script>

<Header />

<section class="canvas">
    <div class="canvas__col">
        {#if showMailSend}
            <!-- восстановление пароля, ссылка ушла, форма отправки шаг2 -->
            <section class="password-recovery-block tail">
                <form action = "/auth/instashpion-login" class="auth-form">
                    <h2 class="password-recovery-block__title tail__title">{$_('resetPasswordRequestForm.title')}</h2>
                    <p class="password-recovery-block__text tail__text">{$_('resetPasswordRequestForm.requestSentDescription')}</p>
                    <button type="submit" class="button button_shadow password-recovery-block__btn w-100pc">{$_('resetPasswordRequestForm.backBtnLabel')}</button>
                </form>
            </section>
        {:else}
            <!-- восстановление пароля, форма отправки шаг1 идет вместе с password-recovery-additional -->
            <section class="password-recovery-block tail">
                <form class="auth-form" on:submit = {onSubmit}>
                    <h2 class="password-recovery-block__title tail__title">{$_('resetPasswordRequestForm.title')}</h2>
                    <p class="password-recovery-block__text tail__text">{$_('resetPasswordRequestForm.description')}</p>
                    <div class="password-recovery-block__form-wrapper form">
                        <input type="email" class={`${emailRed ? 'error' : ''} general-input password-recovery-block__input`}
                               placeholder={$_('resetPasswordRequestForm.emailInputPlaceholder')}
                               bind:value={email}
                        />
                        <button type="submit" class="button button_shadow password-recovery-block__btn" disabled={isLoading || !email || email.length < 3}>
                            <LoadingIcon show={isLoading} width="16" height="16" />
                            {$_('resetPasswordRequestForm.continueBtnLabel')}
                        </button>

                        {#if mainError}
                            <p class="password-recovery-block__form-error tail__error">{mainError}</p>
                        {/if}
                    </div>
                </form>
            </section>
            <section class="password-recovery-block__additional">
                <a href="/auth/instashpion-login" class="button button_textual password-recovery-block__additional-btn">{$_('resetPasswordRequestForm.backBtnLabel')}</a>
            </section>
        {/if}
    </div>
</section>

<Footer {language} />


<style lang="scss">
  @import "style";

  .w-100pc {
    width: 100%;
  }

  .logo {
    &.ru-RU {
      background: url(https://auth.zengram.ru/themes/spy/logo.png) no-repeat center;
      width: 260px;
    }

    &.en-US {
      background: url(https://auth.datajam.pro/themes/spy/datajam-black-logo.png) no-repeat center;
      background-size: 100%;
      width: 170px;
    }
  }
</style>